import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "open", "onClose", "maxWidth", "fullWidth", "modalStyles", "hideOverlay", "disableOverlayClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, isValidElement } from 'react';
import { createPortal } from 'react-dom';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { Size } from './types';
import ModalMenuContext from './modal-menu-context';
import Styled from './modal.styles';
var isValidSingleFragmentChildren = function isValidSingleFragmentChildren(children) {
  return children && /*#__PURE__*/isValidElement(children) && React.Children.count(children) === 1 && children.type === React.Fragment;
};
var Modal = intrinsicComponent(function (_ref, ref) {
  var _children = _ref.children,
    open = _ref.open,
    onClose = _ref.onClose,
    maxWidth = _ref.maxWidth,
    fullWidth = _ref.fullWidth,
    modalStyles = _ref.modalStyles,
    hideOverlay = _ref.hideOverlay,
    disableOverlayClick = _ref.disableOverlayClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var children = isValidSingleFragmentChildren(_children) ? _children.props.children : _children;

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var target = document.querySelector('body');
  useEffect(function () {
    if (open) {
      document.body.classList.add('Modal-open');
    } else {
      document.body.classList.remove('Modal-open');
    }
    return function () {
      document.body.classList.remove('Modal-open');
    };
  }, [open]);
  var handleClose = function handleClose() {
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  useEffect(function () {
    var keyListener = function keyListener(ev) {
      if (ev.key === 'Escape') {
        handleClose();
      }
    };
    document.addEventListener('keydown', keyListener);
    return function () {
      return document.removeEventListener('keydown', keyListener);
    };
  });
  var render = function render() {
    return /*#__PURE__*/React.createElement(ModalMenuContext.Provider, {
      value: {
        modalOpened: Boolean(open)
      }
    }, /*#__PURE__*/React.createElement(Styled.Wrapper, {
      style: _objectSpread({}, modalStyles),
      open: Boolean(open),
      ref: ref
    }, !hideOverlay && /*#__PURE__*/React.createElement(Styled.Overlay, {
      onClick: function onClick() {
        return disableOverlayClick ? null : handleClose();
      },
      open: Boolean(open)
    }), /*#__PURE__*/React.createElement(Styled.Container, _extends({}, rest, {
      maxWidth: maxWidth,
      fullWidth: fullWidth,
      open: Boolean(open)
    }), /*#__PURE__*/React.createElement(Styled.Modal, null, React.Children.map(children, function (child) {
      if ( /*#__PURE__*/isValidElement(child) && child.type.displayName === 'ModalTitle') {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread({
          onClose: handleClose
        }, child.props || {}));
      }
      return child;
    })))));
  };
  return /*#__PURE__*/createPortal(render(), target);
});
export var defaultProps = {
  open: false,
  fullWidth: false,
  disableOverlayClick: false,
  hideOverlay: false,
  maxWidth: Size.Xs
};
Modal.defaultProps = defaultProps;
export var propTypes = {
  onClose: PT.func,
  modalStyles: PT.object,
  disableOverlayClick: PT.bool,
  hideOverlay: PT.bool,
  children: PT.node.isRequired,
  maxWidth: PT.oneOf(objectValues(Size)),
  open: PT.bool,
  fullWidth: PT.bool
};
Modal.propTypes = propTypes;
export default Modal;